import HelpVideos from './HelpVideos';
import HelpFAQ from './HelpFAQ';
import HelpSupport from './HelpSupport';
import HelpGuide from './HelpGuide';
import { Stack, Pivot, PivotItem } from '@fluentui/react';
import { useUiContext } from '../components/Contexts/UIContext/uiCtx';
import { useConfigValuesState } from '../hooks/useConfigValue';

function HelpApp() {
    const { isTeams } = useUiContext();
    const {
        initialData: {
            configuration: { enableCoachmarks },
        },
    } = useConfigValuesState();
    return (
        <Stack horizontalAlign="center">
            <Pivot defaultSelectedKey="video" aria-label="Count and Icon Pivot Example" style={{ width: '100vw', textAlign: 'center' }}>
                <PivotItem itemKey="video" headerText="Video" itemIcon="MSNVideosSolid">
                    <HelpVideos />
                </PivotItem>
                {!isTeams && enableCoachmarks && (
                    <PivotItem itemKey="guide" headerText="Guide" itemIcon="SearchNearby">
                        <HelpGuide />
                    </PivotItem>
                )}
                <PivotItem itemKey="faq" headerText="FAQ" itemIcon="ClipboardList">
                    <HelpFAQ />
                </PivotItem>
                <PivotItem itemKey="support" headerText="Support" itemIcon="ContactHeart">
                    <HelpSupport />
                </PivotItem>
            </Pivot>
        </Stack>
    );
}

export default HelpApp;
